import { render, staticRenderFns } from "./GlobalPartnersStateListView.vue?vue&type=template&id=175075c8&scoped=true"
import script from "./GlobalPartnersStateListView.vue?vue&type=script&lang=js"
export * from "./GlobalPartnersStateListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175075c8",
  null
  
)

export default component.exports